<template>
  <div class="mgt-10px VueTables">
    <div class="table-responsive">
      <v-client-table :data="echeancierPaiement"
                      class='tableWithChildRow childrowEcheancierPaiement'
                      :columns="columns"
                      :options="options"
                      ref="tableEcheancePaiement">
        <div slot="dateEcheance" slot-scope="props">
          {{ props.row.dateEcheance | formatDate }}
        </div>
        <div slot="montant" slot-scope="props" class="right">
          {{ props.row.montant | formatDevise }}
        </div>
        <div slot="montantPaye" slot-scope="props" class="right">
          {{ getMontantPaye(props.row) | formatDevise }}
        </div>
        <div slot="modeReglement" slot-scope="props">
          {{ getModeReglement(props.row.modeReglementId) }}
        </div>
        <div slot="resteAPayer" slot-scope="props" class="right">
          {{ props.row.montant - getMontantPaye(props.row) | formatDevise }}
        </div>
      </v-client-table>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import * as typesParametres from '@/store/modules/parametres-mutation-type';
import {
  TEXTS, RESULTS_PER_PAGE, NO_PER_PAGE_VALUE,
} from '@/configuration/clientTableConf';
import { SENS_VENTE } from '@/configuration/devisConf';
import childRowEcheancierPaiement from './childRowEcheancierPaiement';

const Parametres = createNamespacedHelpers('parametres');

export default {
  props: {
    echeancierPaiement: Array,
    sens: {
      type: String,
      required: false,
      default: 'vente',
    },
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    modesReglement() {
      return this.parametre(typesParametres.PARAMETRES_KEYS.modeReglement);
    },
    columns() {
      return ['dateEcheance', 'montant', 'modeReglement', 'montantPaye', 'resteAPayer', 'commentaire'];
    },
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        headings: {
          dateEcheance: this.$i18n.t('echeancierPaiement.dateEcheance'),
          montant: this.$i18n.t('echeancierPaiement.montantTTC'),
          modeReglement: this.sens === SENS_VENTE
            ? this.$i18n.t('echeancierPaiement.modeReglement')
            : this.$i18n.t('echeancierPaiement.modePaiement'),
          montantPaye: this.$i18n.t('echeancierPaiement.montantPaye'),
          resteAPayer: this.$i18n.t('echeancierPaiement.resteAPayer'),
          commentaire: this.$i18n.t('echeancierPaiement.commentaire'),
        },
        childRow: childRowEcheancierPaiement,
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: TEXTS,
        columnsClasses: {
          dateEcheance: 'colonneWidth150px',
          commentaire: 'is-prewrap',
          montantPaye: 'is-220px-width',
          montant: 'is-220px-width',
          resteAPayer: 'is-220px-width',
        },
        rowClassCallback: ((row) => {
          return !row.actif ? 'textDecorationLineThroughDiv' : '';
        }),
      };
    },
  },
  async mounted() {
    await this.loadParametres([
      typesParametres.PARAMETRES_KEYS.modeReglement,
    ]);
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    getMontantPaye(echeance) {
      let montantPaye = 0;
      if (echeance.montant >= 0) montantPaye = echeance.montant - echeance.resteALettrer;
      else montantPaye = echeance.montant + echeance.resteALettrer;
      return montantPaye;
    },
    getModeReglement(modeReglementId) {
      const modeRegelement = this.modesReglement.find(
        modeReglement => modeReglement.id === modeReglementId,
      );
      if (modeRegelement) return modeRegelement.libelle;
      return null;
    },
  },
};
</script>
